import InfluencerComparison from './influencer-comparison';

export default InfluencerComparison;